import axios from 'axios';

export const formService = {
    getFormsService: (params) => axios.get(`/form-builder`, { auth: true, params: { ...params } }),
    // getFormsService: (params) => axios.get(`/custom-forms`, { auth: true, params: { ...params } }),

    getFormWidthSections: (params) => axios.get(`/form-builder/sections`, { auth: true, params: params }),

    openSectionList: (body) => axios.patch(`/form-builder/open-sections-list`, body, { auth: true }),

    // getBasicFormsService: (model, params) => axios.get(`/form-builder/basic-info/${model}`, { auth: true, params: params }),

    getFormDefaultService: (formId, params) => axios.get(`/form-builder/default-values`, { auth: true, params: params }),

    getFormByIdService: (id, params) => axios.get(`/form-builder/${id}`, { auth: true, params: params }),
    // getFormByIdService: (id) => axios.get(`/custom-forms/${id}`, { auth: true }),

    getFormSettingsService: () => axios.get(`/form-builder/settings`, { auth: true }),
    // getFormSettingsService: () => axios.get(`/custom-forms/settings`, { auth: true }),

    createFormService: (body) => axios.post(`/form-builder`, body, { auth: true }),

    /**
     * Kick off AI generation for a template that already exists. Returns
     * immediately with a conversationId; progress arrives over the socket as
     * `form-ai:*` events.
     */
    startAiGenerationService: (id, body) => axios.post(`/form-builder/${id}/ai-generate`, body, { auth: true }),

    /** Rehydrates the progress modal after a refresh or a dropped socket. */
    getAiGenerationStatusService: (id) => axios.get(`/form-builder/${id}/ai-generate/status`, { auth: true }),
    // createFormService: (body) => axios.post(`/custom-forms`, body,{ auth: true }),

    editFormService: (id, body) => axios.patch(`/form-builder/${id}`, body, { auth: true }),

    deleteFormsService: (id) => axios.delete(`/form-builder/${id}`, { auth: true }),
    // deleteFormsService: (id) => axios.delete(`/custom-forms/${id}`, { auth: true }),

    resendInviteFormService: (params) => axios.post(`/custom-forms-invite/resend-invite`, params, { auth: true }),

    // getClientInviteFormService: (token) => axios.get(`http://localhost:8000/api/custom-forms-invite`, { headers: { 'invite-token': token }, useBaseUrl: false }),
    getClientInviteFormService: (token) => axios.get(`/custom-forms-invite`, { headers: { 'invite-token': token } }),

    // saveInviteFormService: (params, registerToken) => axios.post(`http://localhost:8000/api/custom-forms-invite/save-form`, params, { headers: { 'invite-token': registerToken }, useBaseUrl: false }),
    saveInviteFormService: (params, registerToken) =>
        axios.post(`/custom-forms-invite/save-form`, params, { headers: { 'invite-token': registerToken } }),

    // requestInviteFormService: (inviteToken) => axios.post(`http://localhost:8000/api/custom-forms-invite/request-new-link`, {}, { headers: { 'invite-token': inviteToken }, useBaseUrl: false }),
    requestInviteFormService: (inviteToken) =>
        axios.post(`/custom-forms-invite/request-new-link`, {}, { headers: { 'invite-token': inviteToken } }),

    getClientFiledFormService: (clientId) => axios.get(`/client/intake-from/${clientId}`, { auth: true }),

    clientFormReviewService: (clientId, data, status) =>
        axios.post(`/custom-forms-invite/review/${clientId}/${status}`, data, { auth: true }),

    getFormCustomSections: (clientId) => axios.get(`/client/${clientId}/custom-section`, { auth: true }),
};
